import { useCallback, useState } from 'react';

function useFullModalState<T>() {
    const [open, setOpen] = useState(false);

    const [modalData, setModalData] = useState<T | undefined>();

    const openModal = useCallback(
        (modalData: T) => {
            setModalData(modalData);
            setOpen(true);
        },
        [setOpen]
    );

    const closeModal = useCallback(() => {
        setOpen(false);
        setModalData(undefined);
    }, [setOpen]);

    return { open, openModal, closeModal, modalData };
}

export default useFullModalState;
